import '.a{display:flex;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import '.at{cursor:pointer;}.ssr-plugin'
import '.d7{padding:0.75rem;}.ssr-plugin'
import '.ag{border-radius:1.25rem;}.ssr-plugin'
import '.ao{border:var(--border-subtle);}.ssr-plugin'
import '.ah{background-color:var(--palette-white);}.ssr-plugin'
import '.cj{transition:background-color 0.2s ease;}.ssr-plugin'
import '.e4{width:2.5rem;}.ssr-plugin'
import '.e5{height:2.5rem;}.ssr-plugin'
import '.i5{color:var(--palette-blue-700);}.ssr-plugin'
import '.i6{font-size:0.9rem;}.ssr-plugin'
import '.a9{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a b e f an at d7 ag ao ah cj"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="e4 e5 a f b i5"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="i6 i5 a9"
        >
          {label}
        </span>
      </styled.button>
    )
}